shadow$provide[260] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Label:{enumerable:true, get:function() {
  return Label;
}}});
var UJS = require("../../../util/js.js");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Label extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "bind", "object", "visible", "style", "label", "attach", "geometry", "position",];
  }
  make() {
    let color;
    super.make();
    this._helpers.bind.make([{to:"label.text", trait:"text"}, {to:"geometry.points", trait:"source"}, {to:"geometry.colors", trait:"source"},]);
    if (this.bind.points == null) {
      return;
    }
    if (this.bind.text == null) {
      return;
    }
    const pointDims = this.bind.points.getDimensions();
    const textDims = this.bind.text.getDimensions();
    const textIsSDF = this.bind.text.textIsSDF();
    const items = Math.min(pointDims.items, textDims.items);
    const width = Math.min(pointDims.width, textDims.width);
    const height = Math.min(pointDims.height, textDims.height);
    const depth = Math.min(pointDims.depth, textDims.depth);
    let position = this.bind.points.sourceShader(this._shaders.shader());
    position = this._helpers.position.pipeline(position);
    const sprite = this.bind.text.sourceShader(this._shaders.shader());
    const map = this._shaders.shader().pipe("label.map");
    map.pipe(this.bind.text.textShader(this._shaders.shader()));
    const labelUniforms = {spriteDepth:this.node.attributes["attach.depth"], spriteOffset:this.node.attributes["attach.offset"], spriteSnap:this.node.attributes["attach.snap"], spriteScale:this._attributes.make(this._types.number()), outlineStep:this._attributes.make(this._types.number()), outlineExpand:this._attributes.make(this._types.number()), outlineColor:this.node.attributes["label.background"],};
    this.spriteScale = labelUniforms.spriteScale;
    this.outlineStep = labelUniforms.outlineStep;
    this.outlineExpand = labelUniforms.outlineExpand;
    const snippet = textIsSDF ? "label.outline" : "label.alpha";
    const combine = this._shaders.shader().pipe(snippet, labelUniforms);
    if (this.bind.colors) {
      color = this._shaders.shader();
      this.bind.colors.sourceShader(color);
    }
    const mask = this._helpers.object.mask();
    const styleUniforms = this._helpers.style.uniforms();
    const unitUniforms = this._inherit("unit").getUnitUniforms();
    const uniforms = UJS.merge(unitUniforms, styleUniforms, labelUniforms);
    this.sprite = this._renderables.make("sprite", {uniforms, width, height, depth, items, position, sprite, map, combine, color, mask, linear:true,});
    this._helpers.visible.make();
    return this._helpers.object.make([this.sprite]);
  }
  unmake() {
    this._helpers.bind.unmake();
    this._helpers.visible.unmake();
    this._helpers.object.unmake();
    return this.sprite = null;
  }
  resize() {
    const pointDims = this.bind.points.getActiveDimensions();
    const textDims = this.bind.text.getActiveDimensions();
    const items = Math.min(pointDims.items, textDims.items);
    const width = Math.min(pointDims.width, textDims.width);
    const height = Math.min(pointDims.height, textDims.height);
    const depth = Math.min(pointDims.depth, textDims.depth);
    return this.sprite.geometry.clip(width, height, depth, items);
  }
  change(changed, touched, _init) {
    if (touched["geometry"] || changed["label.text"]) {
      return this.rebuild();
    }
    if (this.bind.points == null) {
      return;
    }
    const {size} = this.props;
    const {outline} = this.props;
    const {expand} = this.props;
    const height = this.bind.text.textHeight();
    const scale = size / height;
    this.outlineExpand.value = expand / scale * 16 / 255;
    this.outlineStep.value = outline / scale * 16 / 255;
    return this.spriteScale.value = scale;
  }
}
Label.initClass();

};